module.exports = __webpack_public_path__ + "static/media/login-logo.ac02a097.png";